import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IKpiTileProps } from './IKpiTileProps';

/**
 * Тайл показника огляду (прототип v4): підпис 12px звичайним регістром, значення 26px/600 у тоні (прострочено — небезпека, термін цього
 * тижня, не призначено, без змін — бурштин; нуль — звичайний колір); «—», коли API не підтримує джерело (причина — у підказці).
 */
export function KpiTile({ kpi, to }: IKpiTileProps) {
  const { t } = useTranslation();
  const className = cx('mp-kpi', kpi.tone === 'bad' && 'is-bad', kpi.tone === 'warn' && 'is-warn');
  const title = kpi.unavailable ? t('overview.unavailable') : undefined;
  const body = (
    <>
      <span className="mp-kpi__label">{t(`overview.kpi.${kpi.key}`)}</span>
      <strong className="mp-kpi__value">{kpi.unavailable ? '—' : kpi.loading ? '…' : kpi.value}</strong>
    </>
  );
  return to ? <Link className={className} to={to} title={title}>{body}</Link> : <div className={className} title={title}>{body}</div>;
}
